import { render, staticRenderFns } from "./CategoriasComponent.vue?vue&type=template&id=4d7875d9&"
import script from "./CategoriasComponent.vue?vue&type=script&lang=js&"
export * from "./CategoriasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports